import { createSelector } from "reselect";

import { getFilters } from "./state-accessors";

export const getSelectedHasETicket = createSelector([getFilters], filters => {
  return filters.has_e_ticket;
});
